// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/settings/Menu14/Item.css
// module id = 2032
// module chunks = 0